import(/* webpackMode: "eager" */ "D:\\GIT Repos\\assistiv\\app\\(portal)\\admin\\(pages)\\courses\\page.tsx")